import { z } from "zod";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";
export const language = z
    .union([
    z.literal("English (CA)").describe("English"),
    z.literal("French (Canada)").describe("Français"),
])
    .describe(createCustomSettings({ isRadioList: true }));
//# sourceMappingURL=languages-list.js.map